// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleAugCap = (value) => ({
  type: actionTypes.SET_VALUE_ModeleAugCap,
  payload: value,
});

export const setTypeModeleAugCap = (type) => ({
  type: actionTypes.SET_TYPE_ModeleAugCap,
  payload: type,
});
export const setActifModeleAugCap = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleAugCap,
  payload: actif,
});

export const setCurrentPageModeleAugCap = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleAugCap,
  payload: page,
});

export const setOrderModeleAugCap = (order) => ({
  type: actionTypes.SET_ORDER_ModeleAugCap,
  payload: order,
});

export const setSortFieldModeleAugCap = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleAugCap,
  payload: field,
});
export const setCategorieModeleAugCap = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleAugCap,
  payload: categorie,
});
